export default __webpack_public_path__ + "static/media/img-0015.f5c17b16.png";